module.exports = __webpack_public_path__ + "img/IMG_2507-2.4ab4de59.jpg";